import api from 'api'

export const removeStep = async (formId, id) => {
  const { data } = await api.delete(`/form/${formId}/step/${id}`)

  return data
}
